import React, { useEffect, useState, useRef } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { MdOutlineVideoLibrary } from "react-icons/md";
// import img1 from "../../Assests_Url/image-teach.png";
// import img2 from "../../Assests_Url/image-video.png";

import img1 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/1. Concept Video within base book.jpg";
import img2 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/2.Both base book and Concept video.jpg";
import img3 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/3. Explanation Video within base book.jpg";
import img4 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/4. Filteration of Metaconten.jpg";
import img5 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/5.Unit  or chapter selection.jpg";
import img6 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/6. Resource Selection.jpg";
import img7 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/7. Search result.jpg";
import img8 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/8. Searched  explantion videi.jpg";
import img9 from "../../Assests_Url/Ulearn_1st/CONCEPT AND EXPLANATION/9. Full view Mode.jpg";

import img11 from "../../Assests_Url/Ulearn_1st/intractive excercise/1. Fill in the blanks with audio input.bmp";
import img12 from "../../Assests_Url/Ulearn_1st/intractive excercise/2. Type the answer then Check.bmp";

import img21 from "../../Assests_Url/Ulearn_1st/INTERACTIVE QUIZZ/1. Chapter wise Self- Assessment.bmp";
import img22 from "../../Assests_Url/Ulearn_1st/INTERACTIVE QUIZZ/2. Student answer and correct answer.bmp";
import img23 from "../../Assests_Url/Ulearn_1st/INTERACTIVE QUIZZ/3. Student answer.bmp";

import img31 from "../../Assests_Url/Ulearn_1st/audio/1.Open a page in the Unit.bmp";
import img32 from "../../Assests_Url/Ulearn_1st/audio/2.Tap on any sentence or word to   Listen Audio.bmp";
import img33 from "../../Assests_Url/Ulearn_1st/audio/3.Audio tools is availabe.bmp";

import img41 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/1.Tap on Notes in the menu on selection of a text.bmp";
import img42 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/2.Notes - Select color  and submit.bmp";
import img43 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/3.Notes - entered.bmp";
import img44 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/4.Notes - Enter content and Save.bmp";
import img45 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/5.Highlight -Menu item.bmp";
import img46 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/6.Highlight - Select color and Submit.bmp";
import img47 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/7.Highlight - listed after creation.bmp";
import img48 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/8.Bookmark - creation.bmp";
import img49 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/9.Book mark - add content and save.bmp";
import img40 from "../../Assests_Url/Ulearn_1st/PERSONALISATION/10.Bookmark - Save and  listing.bmp";

import img51 from "../../Assests_Url/Ulearn_1st/dictionary&translate/1. Inbuilt Dictionary.bmp";
import img52 from "../../Assests_Url/Ulearn_1st/dictionary&translate/2.  Dictionary View.bmp";
import img53 from "../../Assests_Url/Ulearn_1st/dictionary&translate/3.Inbuilt Translator.bmp";
import img54 from "../../Assests_Url/Ulearn_1st/dictionary&translate/4. Language seletion.bmp";
import img55 from "../../Assests_Url/Ulearn_1st/dictionary&translate/5. Selected text is translated to hindi.png";

import img61 from "../../Assests_Url/Ulearn_1st/AI/1. AI is integrated.png";
import img62 from "../../Assests_Url/Ulearn_1st/AI/2.Multiple AI is Available.png";
import img63 from "../../Assests_Url/Ulearn_1st/AI/3.Reposnse from ChatGPT.png";
import img64 from "../../Assests_Url/Ulearn_1st/AI/4.Reposnse from Perplexity.png";

import img71 from "../../Assests_Url/Ulearn_1st/coverage report/1.After using the KATBOOK.bmp";
import img72 from "../../Assests_Url/Ulearn_1st/coverage report/1.Before using the KATBOOK.bmp";

import img81 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/1.Text selection.bmp";
import img82 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/2.Search engine selection.bmp";
import img83 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/3. Bing search result.bmp";
import img84 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/4. Selection of AI search from  in the same page.png";
import img85 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/5. Deepseek search result.bmp";
import img86 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/6. Enclopedia search result.bmp";
import img87 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/7.Select Translate from the menu.bmp";
import img88 from "../../Assests_Url/Ulearn_1st/MULTIPLE SEARCH/8.Select the language  Arabic - View the result.bmp";

import { MdVideoLibrary } from "react-icons/md";
import { PiExamFill } from "react-icons/pi";
import { MdAssignment } from "react-icons/md";
import { RiVolumeUpFill } from "react-icons/ri";
import { FaLanguage } from "react-icons/fa6";
import pers from "../../Assests_Url/gridicons.png";
import aisearch from "../../Assests_Url/ai.png";
import coverage from "../../Assests_Url/cov-report.png";
import mul_search from "../../Assests_Url/multi-search.png";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowUndoCircle } from "react-icons/io5";
import Carousel from "../Carousel/Carousel";

const ULearnFoundation = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const v1 = useRef(null);
  const v2 = useRef(null);
  const v3 = useRef(null);
  const v4 = useRef(null);
  const v5 = useRef(null);
  const v6 = useRef(null);
  const v7 = useRef(null);
  const v8 = useRef(null);
  const v9 = useRef(null);

  const pauseOthers = (current) => {
    [v1, v2, v3, v4, v5, v6, v7, v8, v9].forEach((ref) => {
      if (ref.current && ref.current !== current) {
        ref.current.pause();
      }
    });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";
  const sampleData1 = [
    {
      img: img1,
      title: "Concept Video within base book",
    },
    {
      img: img2,
      title: "Both base book and Concept video",
    },
    {
      img: img3,
      title: "Explanation Video within base book",
    },
    {
      img: img4,
      title: "Filteration of Meta content",
    },
    {
      img: img5,
      title: "Unit or chapter selection",
    },
    {
      img: img6,
      title: "Resource Selection",
    },
    {
      img: img7,
      title: "Search result",
    },
    {
      img: img8,
      title: "Searched explanation video",
    },
    {
      img: img9,
      title: "Full view mode",
    },
  ];

  const sampleData2 = [
    {
      img: img11,
      title: "Fill in the blanks with audio input",
    },
    {
      img: img12,
      title: "Type the answer and check",
    },
  ];

  const sampleData3 = [
    {
      img: img21,
      title: "Chapter wise Self - Assessment",
    },
    {
      img: img22,
      title: "Student answer and correct answer",
    },
    {
      img: img23,
      title: "Student answer",
    },
  ];

  const sampleData4 = [
    {
      img: img31,
      title: "Open a page in the Unit",
    },
    {
      img: img32,
      title: "Tap on any sentence or word to Listen Audio",
    },
    {
      img: img33,
      title: "Audio tools is available",
    },
  ];

  const sampleData5 = [
    {
      img: img41,
      title: "Tap on Notes in the menu on selection of a text",
    },
    {
      img: img42,
      title: "Notes - Select color and submit",
    },
    {
      img: img43,
      title: "Notes - Entered",
    },
    {
      img: img44,
      title: "Notes - Enter content and Save",
    },
    {
      img: img45,
      title: "Highlight - Menu item",
    },
    {
      img: img46,
      title: "Highlight - Select color and Submit",
    },
    {
      img: img47,
      title: "Highlight - Listed after creation",
    },
    {
      img: img48,
      title: "Bookmark - Creation",
    },
    {
      img: img49,
      title: "Bookmark - Add content and save",
    },
    {
      img: img40,
      title: "Bookmark - Save and listing",
    },
  ];

  const sampleData6 = [
    {
      img: img51,
      title: "Inbuilt Dictionary",
    },
    {
      img: img52,
      title: "Dictionary View",
    },
    {
      img: img53,
      title: "Inbuilt Translator",
    },
    {
      img: img54,
      title: "Language Selection",
    },
    {
      img: img55,
      title: "Selected text is translated to hindi",
    },
  ];

  const sampleData7 = [
    {
      img: img61,
      title: "AI is integrated",
    },
    {
      img: img62,
      title: "Multiple AI is Available",
    },
    {
      img: img63,
      title: "Response from ChatGPT",
    },
    {
      img: img64,
      title: "Response from Perplexity",
    },
  ];

  const sampleData8 = [
    {
      img: img71,
      title: "After using the KATBOOK",
    },
    {
      img: img72,
      title: "Before using the KATBOOK",
    },
  ];

  const sampleData9 = [
    {
      img: img81,
      title: "Text selection",
    },
    {
      img: img82,
      title: "Search engine selection",
    },
    {
      img: img83,
      title: "Bing search result",
    },
    {
      img: img84,
      title: "Selection of AI search from in the same page",
    },
    {
      img: img85,
      title: "Deepseek search result",
    },
    {
      img: img86,
      title: "Enclopedia search result",
    },
    {
      img: img87,
      title: "Select Translate from the menu",
    },
    {
      img: img88,
      title: "Select the language Arabic - View the result",
    },
  ];

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          AdminregisterModal={AdminregisterModal}
          setAdminregisterModal={setAdminregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          allCountries={allCountries}
        />
      </div>

      <div className="container-uteach">
        <div className="pt-5">
          <div className="d-flex align-items-center justify-content-between text-center pb-4">
            <div>
              <IoArrowUndoCircle
                size={30}
                className="back-arrow"
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className="found-font">
              {lang === "en"
                ? "ULearn Foundation Level"
                : lang === "hi"
                ? "यूलर्न फाउंडेशन लेवल"
                : null}
            </div>
            <div></div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3">
            <div className="meta-font">
              {" "}
              {lang === "en"
                ? "The Power of Meta Content"
                : lang === "hi"
                ? "मेटा कंटेंट की पॉवर"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "NCERT KATBOOKS are powered by state-of-the-art additional learning resources curated by Subject Matter Experts and top content creators from across the globe."
                : lang === "hi"
                ? "एनसीईआरटी कैटबुक्स विश्व भर के विषय विशेषज्ञों और शीर्ष कंटेंट निर्माताओं द्वारा तैयार किए गए अत्याधुनिक अतिरिक्त शिक्षण संसाधनों द्वारा संचालित हैं।"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "Students can access these ready-to-use digital resources anytime and anywhere to understand concepts better and build clarity for complex topics."
                : lang === "hi"
                ? "छात्र अवधारणाओं को बेहतर ढंग से समझने और जटिल विषयों के लिए स्पष्टता प्राप्त के लिए किसी भी समय और कहीं भी इन उपयोग के लिए तैयार डिजिटल संसाधनों तक पहुंच सकते हैं।"
                : null}{" "}
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">
              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    1.{" "}
                    {lang === "en"
                      ? "Embedded Videos (Concept & Explanation)"
                      : lang === "hi"
                      ? "एम्बेडेड वीडियो (अवधारणा और व्याख्या)"
                      : null}{" "}
                    <MdVideoLibrary size="25" className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Videos are embedded inside the KATBOOK itself to explain difficult or important concepts. By tapping on the play button, students can watch the video directly in the book window, without being redirected to YouTube or any external platform. Longer videos include timestamps for easy navigation."
                      : lang === "hi"
                      ? "कठिन या महत्वपूर्ण अवधारणाओं को समझाने के लिए KATBOOK में ही वीडियो एम्बेडेड हैं। प्ले बटन पर टैप करके, छात्र यूट्यूब या किसी बाहरी प्लेटफॉर्म पर रीडायरेक्ट किए बिना, सीधे पुस्तक विंडो में वीडियो देख सकते हैं। लम्बे वीडियो में आसान नेविगेशन के लिए टाइमस्टैम्प शामिल होते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "Acts as a ready-made visual learning aid for abstract or tough concepts."
                          : lang === "hi"
                          ? "अमूर्त या कठिन अवधारणाओं के लिए एक तैयार दृश्य शिक्षण सहायता के रूप में कार्य करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Makes studying interactive and enjoyable."
                          : lang === "hi"
                          ? "अध्ययन को इंटरैक्टिव और आनंददायक बनाता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Helps students save time by accessing the right explanation without searching elsewhere."
                          : lang === "hi"
                          ? "इससे छात्रों को अन्यत्र खोजे बिना सही स्पष्टीकरण प्राप्त करने में समय की बचत होती है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData1} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v1}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v1.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983300953018368_CONCEPTANDEXPLANATIONS1.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    2.{" "}
                    {lang === "en"
                      ? "Interactive Exercise"
                      : lang === "hi"
                      ? "इंटरैक्टिव अभ्यास"
                      : null}{" "}
                    <PiExamFill size={"20px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "At the end of various sessions, interactive exercises are available in the KATBOOK. Students can complete activities like draw and color, drag-and-drop, or matching tasks."
                      : lang === "hi"
                      ? "विभिन्न सत्रों के अंत में, कैटबुक में इंटरैक्टिव अभ्यास उपलब्ध हैं। छात्र चित्र बनाना और रंग भरना, ड्रैग-एंड-ड्रॉप करना, या मिलान कार्य जैसी गतिविधियाँ पूरी कर सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Encourages self-learning and exploration."
                          : lang === "hi"
                          ? "स्व-शिक्षण और अन्वेषण को प्रोत्साहित करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Makes study sessions fun and engaging."
                          : lang === "hi"
                          ? "अध्ययन सत्रों को मज़ेदार और आकर्षक बनाता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Improves participation and concept recall."
                          : lang === "hi"
                          ? "सहभागिता और अवधारणा स्मरण में सुधार करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData2} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v2}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v2.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983358591143936_INTERACTIVEEXERCISES2.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    3.{" "}
                    {lang === "en"
                      ? "Assessments in KATBOOK"
                      : lang === "hi"
                      ? "कैटबुक में मूल्यांकन"
                      : null}{" "}
                    <MdAssignment size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "KATBOOK includes a wide range of built-in assessments — such as multiple choice, fill-in-the-blanks, and short or long answer formats."
                      : lang === "hi"
                      ? "कैटबुक में कई तरह के अंतर्निहित मूल्यांकन शामिल हैं—जैसे बहुविकल्पीय, रिक्त स्थान भरें, और लघु या दीर्घ उत्तर प्रारूप।"
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "Students can attempt quizzes for instant self-checks."
                          : lang === "hi"
                          ? "छात्र तुरंत स्व-जाँच के लिए प्रश्नोत्तरी का प्रयास कर सकते हैं।"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Helps students track their understanding in real time."
                          : lang === "hi"
                          ? "यह छात्रों को वास्तविक समय में अपनी समझ पर नज़र रखने में मदद करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData3} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v3}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v3.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983476044238848_ASSESSMENTSINKATBOOKS3.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3 pt-5">
            <div className="meta-font">
              {" "}
              {lang === "en"
                ? "INTERACTIVE FEATURES OF KATBOOK"
                : lang === "hi"
                ? "कैटबुक की इंटरैक्टिव विशेषताएँ"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "At UEducate, we believe that education should go beyond textbooks — it should inspire curiosity, foster understanding, and support every learner’s unique journey. NCERT KATBOOKs transform traditional learning materials into a dynamic and interactive experience that empowers students to learn better."
                : lang === "hi"
                ? "यू-एजुकेट में, हमारा मानना है कि शिक्षा पाठ्यपुस्तकों से आगे बढ़नी चाहिए - यह जिज्ञासा को प्रेरित करे, समझ को बढ़ावा दे और प्रत्येक शिक्षार्थी की अनूठी यात्रा का समर्थन करे। एनसीईआरटी कैटबुक्स पारंपरिक शिक्षण सामग्री को एक गतिशील और इंटरैक्टिव अनुभव में बदल देती है जो छात्रों को बेहतर सीखने के लिए सशक्त बनाती है।"
                : null}{" "}
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">
              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    1.{" "}
                    {lang === "en"
                      ? "Audio Book Mode: ON"
                      : lang === "hi"
                      ? "ऑडियो बुक मोड: ऑन"
                      : null}{" "}
                    <RiVolumeUpFill size={"20px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "With “audio on touch,” students can tap on any word, sentence or image and the stories or poems come alive with audio."
                      : lang === "hi"
                      ? '"ऑडियो ऑन टच" के साथ, छात्र किसी भी शब्द, वाक्य या इमेज पर टैप कर सकते हैं और कहानियाँ या कविताएँ ऑडियो के साथ क्रियाशील हो जाती हैं।'
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps students learn correct pronunciation."
                          : lang === "hi"
                          ? "छात्रों को सही उच्चारण सीखने में मदद करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Makes reading interactive and enjoyable."
                          : lang === "hi"
                          ? "पढ़ने को इंटरैक्टिव और आनंददायक बनाता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData4} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v4}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v4.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983476413337600_AudioAndTouchS4.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    2.{" "}
                    {lang === "en"
                      ? "Personalisation"
                      : lang === "hi"
                      ? "चेतनारोपण"
                      : null}{" "}
                    <img src={pers} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Students can highlight important passages, add personal notes, and bookmark lessons within the KATBOOK itself."
                      : lang === "hi"
                      ? "छात्र कैटबुक में ही महत्वपूर्ण अंशों को हाइलाइट कर सकते हैं, व्यक्तिगत नोट्स जोड़ सकते हैं और पाठों को बुकमार्क कर सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Acts like a digital study diary."
                          : lang === "hi"
                          ? "यह एक डिजिटल अध्ययन डायरी की तरह काम करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps in revision and quick reference."
                          : lang === "hi"
                          ? "पुनरावृत्ति और त्वरित संदर्भ में मदद करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Supports better organization of learning."
                          : lang === "hi"
                          ? "सीखने के बेहतर संगठन का समर्थन करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData5} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v5}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v5.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983283043340288_PERSONALISATIONS5.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    3.{" "}
                    {lang === "en"
                      ? "Inbuilt Dictionary & Translator"
                      : lang === "hi"
                      ? "अंतर्निहित शब्दकोश और अनुवादक"
                      : null}{" "}
                    <FaLanguage size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Students can highlight any word for instant meaning from the in-built dictionary. They can also translate words, sentences, or the entire book into the preferred regional language."
                      : lang === "hi"
                      ? "छात्र अंतर्निहित शब्दकोश से किसी भी शब्द का तुरंत अर्थ निकाल सकते हैं। वे शब्दों, वाक्यों या पूरी पुस्तक का अपनी पसंदीदा क्षेत्रीय भाषा में अनुवाद भी कर सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Improves vocabulary and comprehension."
                          : lang === "hi"
                          ? "शब्दावली और समझ में सुधार करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Enables independent learning without external help."
                          : lang === "hi"
                          ? "बाहरी सहायता के बिना स्वतंत्र रूप से सीखने में सक्षम बनाता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Supports bilingual and multilingual learning needs."
                          : lang === "hi"
                          ? "द्विभाषी और बहुभाषी सीखने की ज़रूरतों का समर्थन करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData6} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v6}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v6.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983358247211008_DictionaryTranslateS6.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    4.{" "}
                    {lang === "en"
                      ? "AI Search"
                      : lang === "hi"
                      ? "एआई सर्च"
                      : null}{" "}
                    <img src={aisearch} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "With AI Search, students can highlight any part of the book and ask AI modules to generate summaries, Q&A, or other relevant information for that section."
                      : lang === "hi"
                      ? "एआई सर्च के साथ, छात्र पुस्तक के किसी भी भाग को हाइलाइट कर सकते हैं और एआई मॉड्यूल से उस भाग के लिए सारांश, प्रश्नोत्तर या अन्य प्रासंगिक जानकारी तैयार करने के लिए कह सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Provides access to multiple resources in one place."
                          : lang === "hi"
                          ? "एक ही स्थान पर अनेक संसाधनों तक पहुंच प्रदान करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Strengthens understanding of lessons."
                          : lang === "hi"
                          ? "पाठों की समझ को मज़बूत बनाता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData7} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v7}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v7.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983445874610176_AISEARCHS7.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    5.{" "}
                    {lang === "en"
                      ? "Coverage Report"
                      : lang === "hi"
                      ? "कवरेज रिपोर्ट"
                      : null}{" "}
                    <img src={coverage} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "When connected with KAMPUS during a school-wide rollout, students will be able to see their personal progress — chapters covered, exercises completed, and overall book progress."
                      : lang === "hi"
                      ? "स्कूल-व्यापी रोलआउट के दौरान KAMPUS से जुड़ने पर, छात्र अपनी व्यक्तिगत प्रगति देख पाएँगे—पढ़े गए अध्याय, पूरे किए गए अभ्यास और पुस्तक की समग्र प्रगति।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps track individual study progress."
                          : lang === "hi"
                          ? "व्यक्तिगत अध्ययन प्रगति पर नज़र रखने में मदद करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Identifies areas that need improvement."
                          : lang === "hi"
                          ? "यह उन क्षेत्रों की पहचान करता है जिनमें सुधार की आवश्यकता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData8} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v8}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v8.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983357966192640_CoveragereportS8.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    6.{" "}
                    {lang === "en"
                      ? "Multiple Search"
                      : lang === "hi"
                      ? "बहु-खोज"
                      : null}{" "}
                    <img src={mul_search} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Students can highlight and select any word or text from the KATBOOK and use the Multiple Search feature to find information across:"
                      : lang === "hi"
                      ? "छात्र KATBOOK से किसी भी शब्द या पाठ को हाइलाइट और चुन सकते हैं और बहु-खोज सुविधा का उपयोग करके निम्नलिखित में से किसी भी माध्यम से जानकारी प्राप्त कर सकते हैं:"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Various AI tools like ChatGPT, Gemini, Perplexity"
                          : lang === "hi"
                          ? "विभिन्न AI टूल जैसे चैटGPT, जेमिनी, परप्लेक्सिटी"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Web browsers"
                          : lang === "hi"
                          ? "वेब ब्राउज़र"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Encyclopedia's such as Wikipedia or Britannica"
                          : lang === "hi"
                          ? "विश्वकोश जैसे विकिपीडिया या ब्रिटानिका"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Dictionaries like Merriam-Webster or Oxford"
                          : lang === "hi"
                          ? "शब्दकोश जैसे मेरियम-वेबस्टर या ऑक्सफ़ोर्ड"
                          : null}{" "}
                      </li>
                      {lang === "en"
                        ? "This feature helps students explore beyond the textbook and build deeper understanding."
                        : lang === "hi"
                        ? "यह सुविधा छात्रों को पाठ्यपुस्तक से आगे जाकर समझने और गहरी समझ विकसित करने में मदद करती है।"
                        : null}{" "}
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    {/* <img src={img1} alt="found-img" className="img-video" /> */}
                    <Carousel items={sampleData9} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v9}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v9.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758983408310423552_MULTIPLESEARCHS9.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-start gap-3 pt-5 pb-3">
            <div className="meta-font">
              {" "}
              {lang === "en"
                ? "STUDENT BENEFITS"
                : lang === "hi"
                ? "छात्र लाभ"
                : null}{" "}
            </div>
            <div className="cont-para">
              <ul>
                <li>
                  {" "}
                  {lang === "en"
                    ? "Provides interactive resources to make learning engaging."
                    : lang === "hi"
                    ? "सीखने को रोचक बनाने के लिए इंटरैक्टिव संसाधन प्रदान करता है।"
                    : null}{" "}
                </li>
                <li>
                  {" "}
                  {lang === "en"
                    ? "Encourages self-study and independent exploration."
                    : lang === "hi"
                    ? "स्व-अध्ययन और स्वतंत्र अन्वेषण को प्रोत्साहित करता है।"
                    : null}{" "}
                </li>
                <li>
                  {" "}
                  {lang === "en"
                    ? "Improves understanding, vocabulary, and critical thinking."
                    : lang === "hi"
                    ? "समझ, शब्दावली और आलोचनात्मक सोच में सुधार करता है।"
                    : null}{" "}
                </li>
                <li>
                  {" "}
                  {lang === "en"
                    ? "Helps track progress and stay organized."
                    : lang === "hi"
                    ? "प्रगति पर नज़र रखने और व्यवस्थित रहने में मदद करता है।"
                    : null}{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  );
};

export default ULearnFoundation;
